















































/* 共通 */
import { Component, Vue } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { KanriConstants } from '../fixed/KanriConstants';
import { mailSchedule } from '../store/modules/MailSchedule'; // ストアモジュール

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.11.08 [2023L-08] add
 */
@Component
export default class MailScheduleContentInfo extends ApiAccessBase {
  // 参照モードかどうか
  private isReadMode: boolean = true;
  /**
   * 初期表示
   */
  private created() {
    this.screenTitle = 'メール送信スケジュール登録/メール内容登録';
    this.isReadMode = supervisingModule.IS_MODE_READ;
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_schedule_content_info']);
    // APIアクセス
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + '/content' + mailSchedule.GET_PATH , Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          this.isReadMode = supervisingModule.IS_MODE_READ;
          if (!this.isReadMode) {
              this.backupForm();
            }
        }
      },
    );
  }
  /**
   * 貼付
   */
  private execInsertText() {
    for (const variablecol of Object.keys(this.variablecols)) {
      // 可変項目の使用有無判定
      if (this.variablecolsState[variablecol]) {
        for (const col of Object.keys(this.variablecols[variablecol])) {
          if (KanriConstants.REPLACE_STRING_NAME === this.variablecols[variablecol][col].name) {
            const element2 = document.getElementsByName(KanriConstants.MAIL_TEXT);
            element2[0].focus();
            document.execCommand('insertText', false, this.variablecols[variablecol][col].value);
          }
        }
      }
    }
  }
  /**
   * イメージ反映
   */
  private imageReflection() {
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + '/content/image-reflection' + mailSchedule.GET_PATH, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      this.hrefElement('mailScheduleContentInfo', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        // メール本文イメージ反映
        for (const variablecol of Object.keys(this.variablecols)) {
          if (this.variablecolsState[variablecol]) {
            for (const col of Object.keys(this.variablecols[variablecol])) {
              if (KanriConstants.MAIL_TEXT_IMAGE === this.variablecols[variablecol][col].name) {
                this.variablecols[variablecol][col].value = this.resultData;
              }
            }
          }
        }
      }
    });
  }
  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.IS_MODE_READ) {
      this.back();
    } else {
      // 内容変更ありの場合
      if (!this.isNoChangeFormDataCustom()) {
        if (!window.confirm(Message.I0016)) {
          return;
        }
      }
      this.back();
    }
  }
  /**
   * 戻る
   */
  private back() {
    router.push({ name: 'mailScheduleInfo' });
  }
  /**
   * form変更有無チェック（カスタム）
   * 入力外の項目がformに存在するため標準の判定では実施できない
   */
  private isNoChangeFormDataCustom(): boolean {
    this.createSendForm();
    // チェック対象外項目を空設定する
    this.formData.replaceString = '';
    this.formData.mailTextImage = '';
    this.bkFormData.replaceString = '';
    this.bkFormData.mailTextImage = '';
    if (JSON.stringify(this.bkFormData) !== JSON.stringify(this.formData)) {
      return false;
    }
    return true;
  }
  /**
   * 登録
   */
  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + '/content/update' + mailSchedule.GET_PATH , Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('mailScheduleContentInfo', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        this.backupForm();
      }
    });
  }
}
